import { Popup } from "@/Common/Components/Modals/Popup";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IPatientMedicalNoteModel } from "@/Patient/Models/UI/MedicalNote/IPatientMedicalNoteModel";

interface IPrivateBillCreationWarningPopupProps {
    NoteModel: IPatientMedicalNoteModel;
}

class PrivateBillCreationWarningPopup extends React.Component<IPrivateBillCreationWarningPopupProps, any> {
    private id: string = "privatebillcreationwarningpopup";

    public componentDidMount(): void {
        overlayStore.showOverlay(this.id);
    }

    public componentWillUnmount(): void {
        overlayStore.hideOverlay(this.id);
    }

    public render(): JSX.Element {
        var title = cacheStore.GetString("SaveBillLabel");

        var msg = cacheStore.GetString("SaveBillMessage");

        return (
            <Popup Id={this.id} title={title} closeTarget={LocalPatientOperations.MedicalNote.PrivateBillWarning_Cancel} draggable={true} cssClass="memo">
                <div className="p-body">
                    <div>
                        <span> {msg} </span>
                    </div>
                </div>
                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <div>
                                    <button
                                        className="btn btn-default push-right-5"
                                        onClick={this.CancelClick.bind(this)}
                                    >
                                        {cacheStore.GetString("CancelLabel")}
                                    </button>
                                    <button
                                        className="btn btn-default push-right-5"
                                        disabled={this.props.NoteModel.get("IsPrivateBillSaveLocked")}
                                        onClick={this.SaveAndPrintClick.bind(this)}
                                    >
                                        {cacheStore.GetString("SaveAndPrintLabel")}
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        disabled={this.props.NoteModel.get("IsPrivateBillSaveLocked")}
                                        onClick={this.SaveClick.bind(this)}
                                    >
                                        {cacheStore.GetString("SaveLabel")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    private SaveClick(): void {
        var operation = new LocalEvent(LocalPatientOperations.MedicalNote.PrivateBillWarning_Save);
        LocalEventDispatcher.dispatch(operation);
    }

    private SaveAndPrintClick(): void {
        var operation = new LocalEvent(LocalPatientOperations.MedicalNote.PrivateBillWarning_SaveAndPrint);
        LocalEventDispatcher.dispatch(operation);
    }

    private CancelClick(): void {
        var operation = new LocalEvent(LocalPatientOperations.MedicalNote.PrivateBillWarning_Cancel);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { PrivateBillCreationWarningPopup };
